import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import childStore from '../../../../src/store'

import app from './modules/app'
import users from './modules/account/users'
import userPreferences from './modules/account/user_preferences'
import userSession from './modules/account/user_session'
import departments from './modules/departments'

Vue.use(Vuex)

export default {
  get () {
    return new Vuex.Store({
      plugins: [
        createPersistedState({
          paths: [
            'users',
            'user_session',
            'user_preferences'
          ]
        })
      ],
      modules: Object.assign({}, {
        app,
        users,
        user_preferences: userPreferences,
        user_session: userSession,
        departments
      }, childStore.modules())
    })
  }
}



// WEBPACK FOOTER //
// ./libs/@db2b/keystone/store/index.js